import React, { useState } from "react";
import { api, OWNER_PHONE, OWNER_EMAIL, LOCATION, whatsappLink } from "@/api";
import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { toast } from "sonner";

const Contatti = () => {
  const [f, setF] = useState({ nome: "", email: "", telefono: "", messaggio: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setSending(true);
    try { await api.post("/contact", f); toast.success("Messaggio inviato!"); setF({ nome: "", email: "", telefono: "", messaggio: "" }); }
    catch { toast.error("Errore, riprova"); }
    setSending(false);
  };
  const inp = "w-full bg-[#0B0B0C] border border-white/10 rounded-sm px-3 py-2.5 text-sm text-white focus:border-[#E1BC56] focus:outline-none";
  const lab = "block text-[10px] tracking-widest uppercase text-zinc-500 mb-1.5 font-display";

  return (
    <div className="max-w-6xl mx-auto px-6 py-14">
      <div className="mb-10">
        <div className="text-xs tracking-[0.4em] text-[#E1BC56] font-display mb-2">SIAMO A DISPOSIZIONE</div>
        <h1 className="font-display text-4xl md:text-5xl font-extrabold text-white tracking-widest">CONTATTI</h1>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div>
          <form onSubmit={submit} className="bg-[#121214] border border-white/10 rounded-lg p-6 md:p-8 space-y-4" data-testid="contact-form">
            <div><label className={lab}>Nome *</label><input required className={inp} value={f.nome} onChange={(e) => setF({ ...f, nome: e.target.value })} data-testid="contact-nome" /></div>
            <div><label className={lab}>Email *</label><input required type="email" className={inp} value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="contact-email" /></div>
            <div><label className={lab}>Telefono</label><input className={inp} value={f.telefono} onChange={(e) => setF({ ...f, telefono: e.target.value })} data-testid="contact-telefono" /></div>
            <div><label className={lab}>Messaggio *</label><textarea required rows={5} className={inp} value={f.messaggio} onChange={(e) => setF({ ...f, messaggio: e.target.value })} data-testid="contact-messaggio" /></div>
            <button disabled={sending} type="submit" className="cmc-btn-gold w-full py-3 rounded-sm" data-testid="contact-submit">{sending ? "INVIO..." : "INVIA MESSAGGIO"}</button>
          </form>
        </div>
        <div className="space-y-6">
          <div className="bg-[#121214] border border-white/10 rounded-lg p-6">
            <div className="font-display text-sm font-bold tracking-widest text-[#E1BC56] mb-4">RECAPITI DIRETTI</div>
            <div className="space-y-4">
              <a href={`tel:${OWNER_PHONE.replace(/\s/g, "")}`} className="flex items-start gap-3 hover:text-[#E1BC56] transition" data-testid="contact-tel">
                <Phone className="w-5 h-5 text-[#E1BC56] mt-0.5" />
                <div><div className="text-xs text-zinc-500 tracking-widest uppercase">Telefono</div><div className="text-white">{OWNER_PHONE}</div></div>
              </a>
              <a href={`mailto:${OWNER_EMAIL}`} className="flex items-start gap-3 hover:text-[#E1BC56] transition" data-testid="contact-mail">
                <Mail className="w-5 h-5 text-[#E1BC56] mt-0.5" />
                <div><div className="text-xs text-zinc-500 tracking-widest uppercase">Email</div><div className="text-white">{OWNER_EMAIL}</div></div>
              </a>
              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#E1BC56] mt-0.5" />
                <div><div className="text-xs text-zinc-500 tracking-widest uppercase">Sede</div><div className="text-white">{LOCATION}</div></div>
              </div>
            </div>
          </div>
          <a href={whatsappLink()} target="_blank" rel="noreferrer" className="cmc-btn-gold w-full py-4 rounded-sm flex items-center justify-center gap-2" data-testid="contact-whatsapp">
            <MessageCircle className="w-5 h-5" /> CHATTA SU WHATSAPP
          </a>
          <iframe title="Altamura map" src="https://www.google.com/maps?q=Altamura+BA&output=embed" className="w-full h-64 rounded-lg border border-white/10" />
        </div>
      </div>
    </div>
  );
};

export default Contatti;
